import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_arrows",
  "use": "svg_arrows-usage",
  "viewBox": "0 0 29 28",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 29 28\" id=\"svg_arrows\"><path d=\"M8.667 5.25v17.5M15.667 9.333l4.667-4.666L25 9.333M13.333 19.833 8.666 24.5 4 19.833M20.333 22.75V5.25\" stroke=\"#fff\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol